__turbopack_context__.v({
  "loading": "SocialLoginButton-module__rW9dlq__loading",
  "loadingIndicator": "SocialLoginButton-module__rW9dlq__loadingIndicator",
  "logo": "SocialLoginButton-module__rW9dlq__logo",
  "socialLoginButton": "SocialLoginButton-module__rW9dlq__socialLoginButton",
  "socialLoginButtonInner": "SocialLoginButton-module__rW9dlq__socialLoginButtonInner",
  "socialLoginButtonText": "SocialLoginButton-module__rW9dlq__socialLoginButtonText",
});
